import { pick, omit } from 'lodash';

import { INIT_FORM } from './constants';

export const transformLocation = (data) => {
  const {
    system_status,
    location_group,
    payment_methods,
    payment_channels,
    delivery_couriers,
    first_name,
    last_name,
  } = data?.attributes;

  const args = {
    ...data?.attributes,
    system_status: system_status === 'ACTIVE',
    branches: location_group?.map((item) => item?.branch),
    payment_methods: payment_methods || [],
    payment_channels: payment_channels || [],
    delivery_couriers: delivery_couriers || [],
    first_name: first_name || '',
    last_name: last_name || '',
    has_delivery_options: true,
  };

  return { ...pick(args, Object.keys(INIT_FORM)) };
};

export const transformBranches = (data) => {
  const keys = {
    id: '',
    uuid: '',
    logo_url: '',
    photo_url: '',
    business_name: '',
    branch_name: '',
  };

  const args = {
    ...data?.attributes,
    id: +data?.id,
  };

  return { ...pick(args, Object.keys(keys)) };
};

export const transformPayload = (data) => {
  const { system_status, branches, payment_methods, payment_channels } = data;

  const args = {
    ...data,
    system_status: system_status ? 'ACTIVE' : 'INACTIVE',
    branches: branches?.map((item) => item?.uuid),
    payment_channels: !payment_methods?.includes('PAYMENT_GATEWAY')
      ? []
      : payment_channels,
  };

  return { ...args };
};

export const transformPutPayload = (data) => {
  const { system_status, payment_methods, payment_channels } = data;

  const args = {
    ...omit(data, ['branches', 'email_address', 'mobile_number']),
    system_status: system_status ? 'ACTIVE' : 'INACTIVE',
    payment_channels: !payment_methods?.includes('PAYMENT_GATEWAY')
      ? []
      : payment_channels,
  };

  return { ...args };
};

export const transformPutBranches = (data) => {
  const { branches } = data;

  const args = {
    branches: branches?.map((item) => item?.uuid),
  };

  return { ...args };
};
